import { createReducer, on } from '@ngrx/store';
import { WorkshopStatusState } from '@products/models/workshop-status.model';
import { ResetProductsActions } from '@store/products/product.actions';
import { WorkshopStatusActions } from '@store/products/status/workshop/workshop-status.actions';

export { WorkshopStatusState as State };

export const initialState: WorkshopStatusState = {
  availableSeats: {},
  assignedHolderTariffs: {},
  isWorkshopLoading: false,
  isWorkshopDetailModalOpen: false
};

export const workshopStatusReducer = createReducer(
  initialState,
  on(WorkshopStatusActions.setWorkshopAvailableSeatsStatus, (state, { availableSeats }) => ({
    ...state,
    availableSeats: { ...state.availableSeats, ...availableSeats }
  })),
  on(WorkshopStatusActions.setWorkshopAssignedHolderTariffsStatus, (state, { assignedHolderTariffs }) => ({
    ...state,
    assignedHolderTariffs: { ...state.assignedHolderTariffs, ...assignedHolderTariffs }
  })),
  on(
    WorkshopStatusActions.setWorkshopAvailableSeatsAndAssignedHolderTariffsStatus,
    (state, { assignedHolderTariffs, availableSeats }) => ({
      ...state,
      availableSeats: { ...state.availableSeats, ...availableSeats },
      assignedHolderTariffs: { ...state.assignedHolderTariffs, ...assignedHolderTariffs }
    })
  ),
  on(WorkshopStatusActions.setIsWorkshopLoadingStatus, (state, { isWorkshopLoading }) => ({
    ...state,
    isWorkshopLoading
  })),
  on(WorkshopStatusActions.setInitialIsWorkshopDetailModalOpenStatus, (state) => ({
    ...state,
    isWorkshopDetailModalOpen: false
  })),
  on(WorkshopStatusActions.setIsWorkshopDetailModalOpenStatus, (state, { isWorkshopDetailModalOpen }) => ({
    ...state,
    isWorkshopDetailModalOpen
  })),
  on(WorkshopStatusActions.toggleIsWorkshopDetailModalOpenStatus, (state) => ({
    ...state,
    isWorkshopDetailModalOpen: !state.isWorkshopDetailModalOpen
  })),
  on(WorkshopStatusActions.resetReducer, ResetProductsActions.resetStatusReducer, () => initialState)
);
